
export default class IntegrationPlayerModel {
  constructor(obj) {
    if (obj !== null && obj !== undefined && typeof obj !== 'object') {
      obj = { id: obj };
    }

    obj = obj || {};
    this.id = obj.id;
    this.description = obj.description;
    this.integrationType = obj.integrationType;
  }
}
